export default {
  none: {}
};
